import { PromoListItem } from "@/core/entities/promotion/PromoListItem";
import { NumberFormatType } from "@/core/types";
import { TableColumnType } from "@ir/ui";
import {
  ClaimedCell,
  DateRangeCell,
  MatchesCell,
  PromoNameCell,
  PromoTypeCell,
  PurchaserCell,
  StatusCell,
} from "../components/PromotionsTableCells";

export interface PromotionsTableColumnsOptions {
  isRefreshing: boolean;
  searchKeywords: string[];
  dateFormat: string;
  numberFormat?: NumberFormatType;
}

export const createPromotionsTableColumns = ({
  isRefreshing,
  searchKeywords,
  dateFormat,
  numberFormat,
}: PromotionsTableColumnsOptions): TableColumnType<PromoListItem>[] => [
  {
    title: "Promotion Name",
    dataIndex: "promoName",
    key: "promoName",
    sortColumnKey: "promo_name",
    width: 250,
    fixed: "left",
    verticalAlign: "top",
    cellRender(_value: unknown, record: PromoListItem) {
      return <PromoNameCell record={record} isRefreshing={isRefreshing} searchKeywords={searchKeywords} />;
    },
  },
  {
    title: "Promotion Type",
    dataIndex: "type",
    key: "promoType",
    sortColumnKey: "promo_type",
    width: 180,
    verticalAlign: "top",
    cellRender(_value: unknown, record: PromoListItem) {
      return <PromoTypeCell record={record} isRefreshing={isRefreshing} />;
    },
  },
  {
    title: "Purchaser",
    dataIndex: "purchaserName",
    key: "purchaserName",
    sortColumnKey: "purchaser_name",
    width: 180,
    verticalAlign: "top",
    cellRender(_value: unknown, record: PromoListItem) {
      return <PurchaserCell record={record} isRefreshing={isRefreshing} searchKeywords={searchKeywords} />;
    },
  },
  {
    title: "Date Range",
    dataIndex: "promoStartDate",
    key: "dateRange",
    sortColumnKey: "start_date",
    width: 180,
    verticalAlign: "top",
    cellRender(_value: unknown, record: PromoListItem) {
      return <DateRangeCell record={record} isRefreshing={isRefreshing} dateFormat={dateFormat} />;
    },
  },
  {
    title: "Claimed",
    dataIndex: "financials",
    key: "claimed",
    sortColumnKey: "previously_claimed",
    width: 120,
    align: "right",
    verticalAlign: "top",
    cellRender(_value: unknown, record: PromoListItem) {
      return <ClaimedCell record={record} isRefreshing={isRefreshing} numberFormat={numberFormat} />;
    },
  },
  {
    title: "Applied",
    dataIndex: "matchCount",
    key: "matchCount",
    sortColumnKey: "match_count",
    width: 100,
    align: "right",
    verticalAlign: "top",
    cellRender(_value: unknown, record: PromoListItem) {
      return <MatchesCell record={record} isRefreshing={isRefreshing} />;
    },
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    sortColumnKey: "status",
    width: 120,
    verticalAlign: "top",
    cellRender(_value: unknown, record: PromoListItem) {
      return <StatusCell record={record} isRefreshing={isRefreshing} />;
    },
  },
];
